import { createMsg } from 'action-typed';

import { Messages, Product, ProductEvents } from './types';

export const ProductMessages = createMsg<Messages>();

export function viewProduct(product: Product) {
    return ProductMessages(ProductEvents.VIEW_PRODUCT, product);
}
